import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmar-servicio-dialog',
  templateUrl: './confirmar-servicio-dialog.component.html',
})
export class ConfirmarServicioDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmarServicioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
